export default {
  priceList: [],
  catalog: [],
  selectedPriceListItem: null,
}
